import script from "./SegmentedControl.vue?vue&type=script&setup=true&lang=js"
export * from "./SegmentedControl.vue?vue&type=script&setup=true&lang=js"

import "./SegmentedControl.vue?vue&type=style&index=0&id=0a674e90&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a674e90"]])

export default __exports__